'use strict';

(function () {
  var cta = document.querySelectorAll('.cta + .cta');

  if (!cta) {
    return;
  }

  cta.forEach(function (el, i) {
    var ctaSecond = el;
    var ctaFirst = ctaSecond.previousElementSibling;

    // faq
    var ctas = document.createElement('div');
    ctas.className = 'cta-group';

    ctaFirst.parentElement.insertBefore(ctas, ctaFirst);
    ctas.appendChild(ctaFirst);
    ctas.appendChild(ctaSecond);
  });
})();